/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
// Default legacy Underscore templates used by main display app.
var Templates = {};
var _underscoreTpl = [ 'browserSupport', 'inviteModal','inlineMessage','metricComponent','metricItemGraph','metricTemplate',
						'userAuthContainer', 'userAuthButton', 'forms/multiOptins',
						'messaging','quizAnswerResponseDialog','quizDialog','recaptcha' ];

Templates = cacheTemplates(_underscoreTpl, Templates);
export default Templates;

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
// Subset of legacy Underscore templates used only by rights app.
var RightsTemplates = {};
var _rightsUnderscoreTpl = ['inviteModal','inlineMessage'];
RightsTemplates = cacheTemplates(_rightsUnderscoreTpl, RightsTemplates);
export { RightsTemplates };

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
// Cache the given array of templates.
function cacheTemplates(templates, cache) {

	for(let tpl in templates){
		let tplName = templates[tpl];
		let tplFunc = require("./"+tplName+".ejs");
		if(tplFunc && "function"===typeof tplFunc){
			cache[tplName] = tplFunc;
		}
	}

	return cache;
}
